module.exports = "<div class=\"tab-wrapper\" *ngIf=\"active$ | async\">\n\t<ng-content></ng-content>\n</div>"